import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, normalizeStyle as _normalizeStyle, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-5949573c"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  key: 0,
  style: {
    "width": "100%"
  }
};
const _hoisted_2 = {
  class: "header"
};
const _hoisted_3 = {
  class: "cms-page-title"
};
const _hoisted_4 = {
  class: "relation"
};
const _hoisted_5 = {
  class: "btnContainer"
};

const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "grid-content ep-bg-purple"
}, null, -1));

const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "grid-content ep-bg-purple-light"
}, null, -1));

const _hoisted_8 = {
  class: "card_footer"
};
const _hoisted_9 = {
  class: "button-area"
};
import { reactive, ref, computed } from 'vue';
import { ElMessage } from 'element-plus';
import { useRoute, useRouter } from 'vue-router';
import { useCommon } from '@/store/useCommon';
import { editCheckStateApi, editReleaseStateApi } from '@/api/live';
import { useI18n } from 'vue-i18n';
import { liveStore } from '@/store/liveStore';
import { storeToRefs } from 'pinia';
import { ProgramTypeObject, transferProtocolObj } from '@/assets/config/dicts';
import { getCurrentTime } from '@/utils/timeFormat';
import BatchDialog from './batchDialog.vue';
import { findLabel } from '@/utils/tools.ts';
export default /*#__PURE__*/_defineComponent({
  __name: 'batchOperation',
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    mode: {
      type: String,
      default: 'state'
    }
  },
  emits: ['update:modelValue', 'updateList', 'cancel'],

  setup(__props, {
    emit
  }) {
    const props = __props;
    const {
      t
    } = useI18n();
    const cpspId = useCommon().userData.cid[0];
    const router = useRouter();
    const route = useRoute();
    const languageList = ref([]);
    const loading = ref(false);
    const relationData = ref([]);
    const store = liveStore();
    let selectedChannel = storeToRefs(liveStore()).selectdChannel; //pinia中存的从上一步传过来的列表

    const sourceData = ref([]);
    const dataTable = ref(null);
    const selectedKeyList = ref([]); //多选框选中的列表

    const currentPage = ref(1);
    const pageSize = ref(10);
    const channelList = computed(() => {
      return selectedChannel.value.length > 0 ? selectedChannel.value.slice((currentPage.value - 1) * pageSize.value, currentPage.value * pageSize.value) : [];
    });

    const rowKey = row => {
      return row.id;
    };

    const returnBtnDisabled = ref(false);

    const findLabelNew = (dataList, value) => {
      if (!value) return '';
      let keyArr = value.split(',');
      let result = [];
      keyArr.forEach(item => {
        dataList.forEach(val => {
          if (val.value == item) {
            result.push(val.label);
          }
        });
      });
      return result.join(',');
    };

    const ReviewStatus = {
      '0': t('未审核'),
      '1': t('通过'),
      '2': t('未通过'),
      '3': t('终端审核'),
      '4': t('退回审核')
    };
    const ReleaseStatus = {
      '0': t('未上线'),
      '1': t('已上线'),
      '2': t('已下线'),
      '3': t('退回审核')
    };

    const handleSelectionChange = val => {
      console.log('val', val);
      selectedKeyList.value = val;
    };

    watch(() => dataTable.value, (newVal, oldVal) => {
      if (newVal !== null) {
        dataTable.value.toggleAllSelection(); //默认全选

        selectedKeyList.value = selectedChannel.value;
      }
    });
    watch(() => props.modelValue, (newVal, oldVal) => {
      if (!newVal) {
        // 模块隐藏时还原数据
        store.clearSelectedChannel();
        pageSize.value = 10;
        currentPage.value = 1;
        sourceData.value = [];
      } else {
        selectedChannel = storeToRefs(liveStore()).selectdChannel;
        sourceData.value = JSON.parse(JSON.stringify(selectedChannel.value));
        returnBtnDisabled.value = sourceData.value[0].releaseState === 1; //已经上线的频道禁用退回审核按钮
      }
    }, {
      immediate: true,
      deep: true
    });

    const editCheckState = async (channelIds, state) => {
      loading.value = true;
      const {
        data,
        code,
        msg
      } = await editCheckStateApi({
        channelIds,
        state
      });

      if (code == '0') {
        loading.value = false;
        ElMessage({
          type: 'success',
          message: t('退回审核成功')
        });
        store.clearSelectedChannel(); //清空缓存的数据

        emit('update:modelValue', false);
        emit('updateList');
      } else {
        loading.value = false;
        ElMessage({
          type: 'error',
          message: msg
        });
      }
    };

    const editReleaseState = async (channelIds, state) => {
      loading.value = true;
      const {
        data,
        code,
        msg
      } = await editReleaseStateApi({
        channelIds,
        state
      });

      if (code == '0') {
        loading.value = false;
        ElMessage({
          type: 'success',
          message: 'ok'
        });
        store.clearSelectedChannel(); //清空缓存的数据

        emit('update:modelValue', false);
        emit('updateList');
      } else {
        loading.value = false;
        ElMessage({
          type: 'error',
          message: msg
        });
      }
    };

    const handleClick = state => {
      if (selectedKeyList.value.length === 0) return false; // 改变的状态是否跟初始的一样，有需求可以用下面的,不过在变更其他状态再变更回来的时候无效
      // let changeSameState = selectedKeyList.value.filter(item => item[props.mode==='state'?'state':'releaseState'] == state).length > 0 //判断改变的状态是否与一开始一样
      // if(changeSameState) return false

      let channelIds = selectedKeyList.value.map(item => item.id);
      selectedChannel.value.forEach(item => {
        channelIds.forEach(id => {
          if (item.id === id) {
            item.isChange = 1;
            item[props.mode === 'state' ? 'state' : 'releaseState'] = state;
          }
        });
      });
    }; // 返回按钮的回调


    const back = () => {
      emit('update:modelValue', false);
      emit('cancel', true);
    };

    const handleSubmit = () => {
      const channelIsChange = selectedKeyList.value.filter(item => item.isChange === 1).length > 0;
      const stateArr = Array.from(new Set(selectedKeyList.value.map(item => props.mode == 'state' ? item.state : item.releaseState))); // 选中的行的state/releaseState组成的数据

      let isChangeSameState = stateArr.length === 1 ? true : false;
      if (selectedKeyList.value.length === 0) return ElMessage({
        type: 'error',
        message: t('请勾选需要批量修改状态的频道')
      });
      if (!channelIsChange) return ElMessage({
        type: 'error',
        message: t('请选择状态进行批量修改')
      });
      if (!isChangeSameState && selectedKeyList.value.length !== 0) return ElMessage({
        type: 'error',
        message: t('修改的频道状态需一致')
      });
      dialogObj.dialogVisible = true;
      let status = props.mode === 'state' ? ReviewStatus[stateArr[0]] : ReleaseStatus[stateArr[0]]; //要改变的状态

      switch (status) {
        case t('通过'):
          dialogObj.text = `${t('确认将选中频道通过审核吗')}?`;
          dialogObj.checkboxLabel = t('直接上线频道');
          break;

        case t('未通过'):
          dialogObj.placeholder = t('请输入不通过原因');
          break;

        case t('已下线'):
          dialogObj.text = `${t('确认将选中频道下线')}?`;
          dialogObj.checkboxLabel = t('直接退回审核修改');
          dialogObj.placeholder = t('请输入下线原因(选填)');
          break;

        default:
          dialogObj.text = t('确认是否修改成红色文字的状态');
          break;
      }
    };

    const onConfirm = async (failReason, otherOperation) => {
      // otherOperation: 'online'||'backToCheck' 勾选上线或退回审核后会返回的字符串
      // 批量修改审核状态
      dialogObj.dialogVisible = false;
      loading.value = true;
      const channelIds = selectedKeyList.value.map(item => item.id);

      if (props.mode == 'state') {
        const state = selectedKeyList.value.map(item => item.state)[0];
        let params = {
          channelIds,
          state
        };
        if (state === 2) params.checkFailedReason = failReason;
        await editCheckStateApi(params).then(res => {
          // todo:提示信息不明确
          let msg = state === 1 ? '审核通过' : state === 2 ? '审核不通过' : '退回审核';
          ElMessage({
            type: 'success',
            message: t(msg)
          });
        }).catch(err => {
          console.log('267err', err);
        });

        if (otherOperation === 'online') {
          await editReleaseStateApi({
            channelIds,
            state: 1
          }).then(res => {
            ElMessage({
              type: 'success',
              message: t('上线成功')
            });
          }).catch(err => {
            console.log('273err', err);
          });
        }
      } else {
        // 批量修改上下线状态
        const state = selectedKeyList.value.map(item => item.releaseState)[0];
        let params = {
          channelIds,
          state
        };
        if (state === 2) params.offlineReason = failReason; //退回审核要调修改审核状态的接口

        if (state === 3) {
          editCheckState(channelIds, 4);
        } else {
          await editReleaseStateApi(params).then(res => {
            ElMessage({
              type: 'success',
              message: t(`${state === 1 ? '上线' : '下线'}成功`)
            });
          }).catch(err => {
            console.log('273err', err);
          });

          if (otherOperation === 'backToCheck') {
            editCheckStateApi({
              channelIds,
              state: 4
            }).then(res => {
              ElMessage({
                type: 'success',
                message: t('退回审核成功')
              });
            }).catch(err => {
              console.log('err293', err);
            });
          }
        }
      }

      loading.value = false;
      emit('update:modelValue', false);
      emit('updateList');
      dialogObj.checkboxLabel = '';
      dialogObj.placeholder = '';
      dialogObj.text = '';
    };

    const handleSizeChange = val => {
      pageSize.value = val;
    };

    const handleCurrentChange = val => {
      currentPage.value = val;
    };

    const dialogObj = reactive({
      dialogVisible: false,
      title: '确认页',
      text: '',
      width: '30%',
      successBtnText: '确定',
      closeBtnText: '取消',
      isFooter: true,
      checkboxLabel: '',
      placeholder: ''
    }); // 取消

    const onDialogClose = () => {
      dialogObj.dialogVisible = false;
      dialogObj.checkboxLabel = '';
      dialogObj.placeholder = '';
      dialogObj.text = '';
    };

    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");

      const _component_el_table_column = _resolveComponent("el-table-column");

      const _component_el_table = _resolveComponent("el-table");

      const _component_el_col = _resolveComponent("el-col");

      const _component_el_row = _resolveComponent("el-row");

      const _component_el_card = _resolveComponent("el-card");

      const _directive_loading = _resolveDirective("loading");

      return __props.modelValue ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.$t('批量操作')), 1), _createVNode(_component_el_button, {
        type: "primary",
        onClick: back
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('返回')), 1)]),
        _: 1
      })]), _createVNode(_component_el_card, null, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [__props.mode === 'state' ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 0
        }, [_createVNode(_component_el_button, {
          type: "green",
          onClick: _cache[0] || (_cache[0] = $event => handleClick(1))
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('批量通过')), 1)]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[1] || (_cache[1] = $event => handleClick(3))
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('批量终端审核')), 1)]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "yellow",
          onClick: _cache[2] || (_cache[2] = $event => handleClick(2))
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('批量不通过')), 1)]),
          _: 1
        })], 64)) : (_openBlock(), _createElementBlock(_Fragment, {
          key: 1
        }, [_createVNode(_component_el_button, {
          type: "green",
          onClick: _cache[3] || (_cache[3] = $event => handleClick(1))
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('批量上线')), 1)]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "yellow",
          onClick: _cache[4] || (_cache[4] = $event => handleClick(2))
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('批量下线')), 1)]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          disabled: returnBtnDisabled.value,
          onClick: _cache[5] || (_cache[5] = $event => handleClick(3))
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('批量退回审核')), 1)]),
          _: 1
        }, 8, ["disabled"])], 64))]), _createVNode(_component_el_table, {
          data: _unref(selectedChannel),
          ref_key: "dataTable",
          ref: dataTable,
          "row-key": rowKey,
          style: {
            "width": "100%"
          },
          border: "",
          "header-cell-style": {
            background: '#eff5fb',
            color: 'black'
          },
          onSelectionChange: handleSelectionChange
        }, {
          default: _withCtx(() => [_createVNode(_component_el_table_column, {
            type: "selection",
            "reserve-selection": true
          }), _createVNode(_component_el_table_column, {
            prop: "name",
            label: _ctx.$t('频道名称'),
            "show-overflow-tooltip": true,
            sortable: ""
          }, null, 8, ["label"]), _createVNode(_component_el_table_column, {
            prop: "callSign",
            label: _ctx.$t('节目识别号'),
            "show-overflow-tooltip": true,
            width: "200",
            sortable: ""
          }, null, 8, ["label"]), _createVNode(_component_el_table_column, {
            prop: "transferProtocol",
            label: _ctx.$t('传输协议'),
            "show-overflow-tooltip": true,
            width: "200",
            sortable: ""
          }, {
            default: _withCtx(scope => [_createTextVNode(_toDisplayString(findLabelNew(_unref(transferProtocolObj), scope.row.transferProtocol)), 1)]),
            _: 1
          }, 8, ["label"]), _createVNode(_component_el_table_column, {
            prop: "programType",
            label: _ctx.$t('编码标准'),
            width: "200",
            sortable: ""
          }, {
            default: _withCtx(scope => [_createTextVNode(_toDisplayString(_unref(findLabel)(_unref(ProgramTypeObject), scope.row.programType)), 1)]),
            _: 1
          }, 8, ["label"]), __props.mode === 'state' ? (_openBlock(), _createBlock(_component_el_table_column, {
            key: 0,
            prop: "state",
            label: _ctx.$t('审核状态'),
            width: "200"
          }, {
            default: _withCtx(scope => [_createElementVNode("span", {
              style: _normalizeStyle({
                color: scope.row.isChange ? 'red' : ''
              })
            }, _toDisplayString(ReviewStatus[scope.row.state]), 5)]),
            _: 1
          }, 8, ["label"])) : (_openBlock(), _createBlock(_component_el_table_column, {
            key: 1,
            prop: "releaseState",
            label: _ctx.$t('上线状态')
          }, {
            default: _withCtx(scope => [_createElementVNode("span", {
              style: _normalizeStyle({
                color: scope.row.isChange ? 'red' : ''
              })
            }, _toDisplayString(ReleaseStatus[scope.row.releaseState]), 5)]),
            _: 1
          }, 8, ["label"])), _createVNode(_component_el_table_column, {
            prop: "createTime",
            label: _ctx.$t('创建时间'),
            sortable: ""
          }, {
            default: _withCtx(scope => [_createTextVNode(_toDisplayString(_unref(getCurrentTime)(scope.row.createTime)), 1)]),
            _: 1
          }, 8, ["label"])]),
          _: 1
        }, 8, ["data"])]), _createVNode(_component_el_row, null, {
          default: _withCtx(() => [_createVNode(_component_el_col, {
            span: 12
          }, {
            default: _withCtx(() => [_hoisted_6]),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 12
          }, {
            default: _withCtx(() => [_hoisted_7]),
            _: 1
          })]),
          _: 1
        }), _createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, [_createVNode(_component_el_button, {
          type: "default",
          onClick: back
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('取消')), 1)]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: handleSubmit
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('确定')), 1)]),
          _: 1
        })])])]),
        _: 1
      }), dialogObj.dialogVisible ? (_openBlock(), _createBlock(BatchDialog, {
        key: 0,
        "dialog-object": dialogObj,
        onDialogClose: onDialogClose,
        onDialogSuccess: onConfirm
      }, null, 8, ["dialog-object"])) : _createCommentVNode("", true)])), [[_directive_loading, loading.value]]) : _createCommentVNode("", true);
    };
  }

});